import {
  EditNote,
  Email,
  Settings,
  AccountBalanceWallet,
} from "@mui/icons-material";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AssessmentIcon from "@mui/icons-material/Assessment";
import BusinessIcon from "@mui/icons-material/Business";
import ConstructionIcon from "@mui/icons-material/Construction";
import FlagCircleIcon from "@mui/icons-material/FlagCircle";
// import GroupIcon from "@mui/icons-material/Group";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import MapIcon from "@mui/icons-material/Map";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import ReceiptIcon from "@mui/icons-material/Receipt";
import TimelineIcon from "@mui/icons-material/Timeline";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import CreditLimitRequest from "assets/navigationIcons/creditLimitRequests.svg?react";
import CRMFunctionsIcon from "assets/navigationIcons/crm-functions.svg?react";
import InvoiceStatusIcon from "assets/navigationIcons/invoice-status.svg?react";
import LeadsTableIcon from "assets/navigationIcons/leads-table.svg?react";
import LeadsIcon from "assets/navigationIcons/leads.svg?react";
// import LeavesIcon from "assets/navigationIcons/leaves.svg?react";
import OrgChart from "assets/navigationIcons/org-chart.svg?react";
import SOFR from "assets/navigationIcons/sofr.svg?react";
// import SupportTicket from "assets/navigationIcons/ticket-support.svg?react";

import {
  // ACCOUNTS,
  BALANCES_LINK,
  BILLINGS_LINK,
  CREDIT_LIMITS_LINK,
  EMAILS_LINK,
  FUNDER_LINK,
  FUNDER_MANAGEMENT_LINK,
  FUNDING_ADMIN,
  FUNDING_MEMBER,
  INCOMLEND_INTERNAL_LINK,
  FINANCE_MEMBER,
  FINANCE_ADMIN,
  IT_LINK,
  LEADS,
  LEADS_TABLE,
  LEGAL_LINK,
  MAPS,
  ORG_CHART_LINK,
  SOFR_LINK,
  // SUPPORT,
  TAX_INVOICES_LINK,
  TERMSHEETS_LINK,
  WITHDRAWL_DEPOSIT_LINK,
} from "codes";
import { PERMISSIONS } from "permissions";
import { menuStyling as styling } from "styles/theme";

export const INVOICE_FINANCING_MENU_TITLE = "Invoice Financing";
export const WITHDRAWL_DEPOSITS_MENU_TITLE = "Withdraw/Deposits";

interface Item {
  title: string;
  icon: any;
  activeColor: string;
  iconActiveColor: string;
  iconInactiveColor: string;
  circularBackground: boolean;
  link: string;
  match?: (x: string) => boolean;
  items?: Item[];
  permission?: string;
  disabled?: boolean;
}

export default [
  {
    title: "Dashboard",
    icon: AssessmentIcon,
    link: `${INCOMLEND_INTERNAL_LINK}`,
    match: (path) => path === `${INCOMLEND_INTERNAL_LINK}`,
    ...styling,
    permission: PERMISSIONS.show_dashboard,
  },
  // {
  //   title: "Tasks",
  //   icon: SupportTicket,
  //   link: `${INCOMLEND_INTERNAL_LINK}${SUPPORT}`,
  //   match: (path) => path === `${INCOMLEND_INTERNAL_LINK}${SUPPORT}`,
  //   ...styling,
  //   permission: PERMISSIONS.show_support_tickets,
  // },
  {
    title: "CRM Functions",
    icon: CRMFunctionsIcon,
    link: ``,
    match: (path) => path === "",
    ...styling,

    items: [
      {
        title: "Credit Limits",
        icon: CreditLimitRequest,
        link: `${INCOMLEND_INTERNAL_LINK}${CREDIT_LIMITS_LINK}`,
        match: (path) =>
          path === `${INCOMLEND_INTERNAL_LINK}${CREDIT_LIMITS_LINK}` ||
          path.startsWith(`${INCOMLEND_INTERNAL_LINK}${CREDIT_LIMITS_LINK}/`),
        ...styling,
        permission: PERMISSIONS.show_credit_limits,
      },
      // {
      //   title: "Accounts",
      //   icon: GroupIcon,
      //   link: `${INCOMLEND_INTERNAL_LINK}${ACCOUNTS}`,
      //   ...styling,
      //   permission: PERMISSIONS.show_accounts,
      // },
      {
        title: "Termsheets",
        icon: EditNote,
        link: `${INCOMLEND_INTERNAL_LINK}${TERMSHEETS_LINK}`,
        ...styling,
        permission: PERMISSIONS.show_termsheets,
      },
      {
        title: "Billings",
        icon: AccountBalanceWalletIcon,
        link: `${INCOMLEND_INTERNAL_LINK}${BILLINGS_LINK}`,
        ...styling,
        permission: PERMISSIONS.show_billings,
      },
      {
        title: "Accounts",
        icon: LeadsIcon,
        link: `${INCOMLEND_INTERNAL_LINK}${LEADS}`,
        ...styling,
        match: (path) => path === `${INCOMLEND_INTERNAL_LINK}${LEADS}`,
        permission: PERMISSIONS.show_leads,
      },
      {
        title: "Maps",
        icon: MapIcon,
        link: `${INCOMLEND_INTERNAL_LINK}${MAPS}`,
        ...styling,

        permission: PERMISSIONS.show_maps,
      },
      {
        title: "Users",
        ...styling,
        icon: LeadsTableIcon,
        link: `${INCOMLEND_INTERNAL_LINK}${LEADS_TABLE}`,
        ...styling,
        match: (path) => path === `${INCOMLEND_INTERNAL_LINK}${LEADS_TABLE}`,
        permission: PERMISSIONS.show_maps,
      },
      {
        title: "Countries",
        icon: FlagCircleIcon,
        link: `${INCOMLEND_INTERNAL_LINK}${LEGAL_LINK}`,
        match: (path) => path === `${INCOMLEND_INTERNAL_LINK}${LEGAL_LINK}`,
        ...styling,

        permission: PERMISSIONS.show_countries,
      },
      {
        title: "Balances",
        icon: PriceChangeIcon,
        link: `${INCOMLEND_INTERNAL_LINK}${BALANCES_LINK}`,
        ...styling,
        match: (path) => path === `${INCOMLEND_INTERNAL_LINK}${BALANCES_LINK}`,
        permission: PERMISSIONS.show_balances,
      },
      {
        title: "Tax Invoices",
        icon: RequestPageIcon,
        link: `${INCOMLEND_INTERNAL_LINK}${TAX_INVOICES_LINK}`,
        ...styling,
        match: (path) =>
          path === `${INCOMLEND_INTERNAL_LINK}${TAX_INVOICES_LINK}`,
        permission: PERMISSIONS.show_tax_invoices,
      },
      {
        title: "Emails",
        icon: Email,
        link: `${INCOMLEND_INTERNAL_LINK}${EMAILS_LINK}`,
        ...styling,
        permission: PERMISSIONS.show_emails,
      },
    ],
  },
  {
    title: "CRM Reports",
    icon: AssessmentIcon,
    match: (path) => path === "",
    link: ``,
    ...styling,
    items: [
      {
        title: "Opportunities Pipeline",
        icon: AssessmentIcon,
        link: `${INCOMLEND_INTERNAL_LINK}/onboarding-statuses`,
        match: (path) =>
          path === `${INCOMLEND_INTERNAL_LINK}/onboarding-statuses`,
        ...styling,

        permission: PERMISSIONS.show_statuses,
      },
      {
        title: "Onboarding Pipeline",
        icon: TimelineIcon,
        link: `${INCOMLEND_INTERNAL_LINK}/onboardings`,
        match: (path) => path === `${INCOMLEND_INTERNAL_LINK}/onboardings`,
        ...styling,

        permission: PERMISSIONS.show_onboardings,
      },
      {
        title: "Invoice Statuses",
        icon: InvoiceStatusIcon,
        link: `${INCOMLEND_INTERNAL_LINK}${FUNDER_LINK}`,
        ...styling,
        permission: PERMISSIONS.show_invoice_statuses,
      },
      {
        title: "Credit Limit Pipelines",
        icon: AssessmentIcon,
        link: `${INCOMLEND_INTERNAL_LINK}/credit-limits-opportunities`,
        match: (path) =>
          path === `${INCOMLEND_INTERNAL_LINK}/credit-limits-opportunities`,
        ...styling,
        permission: PERMISSIONS.show_cl_report,
      },

      {
        title: "SOFR Rates",
        icon: SOFR,
        link: `${INCOMLEND_INTERNAL_LINK}${SOFR_LINK}`,
        ...styling,
        match: (path) => path === `${INCOMLEND_INTERNAL_LINK}${SOFR_LINK}`,
        permission: PERMISSIONS.show_balances,
      },
    ],
  },
  {
    title: INVOICE_FINANCING_MENU_TITLE,
    icon: AssessmentIcon,
    // Show for both Operation Admin and IT Admin
    match: (path: string) => path === "",
    link: ``,
    ...styling,
    items: [
      // {
      //   title: "Accounts",
      //   icon: GroupIcon,
      //   link: `${INCOMLEND_INTERNAL_LINK}/invoice-onboarding/accounts`,
      //   match: (path: string) => {
      //     return (
      //       path ===
      //         `${INCOMLEND_INTERNAL_LINK}/invoice-onboarding/accounts` ||
      //       path.startsWith(
      //         `${INCOMLEND_INTERNAL_LINK}/invoice-onboarding/accounts/`,
      //       )
      //     );
      //   },
      //   ...styling,
      //   permission: PERMISSIONS.show_all_accounts,
      // },
      {
        title: "Invoices",
        icon: ReceiptIcon,
        link: `${INCOMLEND_INTERNAL_LINK}/invoice-onboarding/invoices`,
        match: (path: string) =>
          path === `${INCOMLEND_INTERNAL_LINK}/invoice-onboarding/invoices`,
        ...styling,
        permission: PERMISSIONS.show_all_invoices,
      },
      // {
      //   title: "Invoice Allocation New",
      //   icon: ReceiptIcon,
      //   link: `${INCOMLEND_INTERNAL_LINK}/invoice-allocation-new`,
      //   match: (path: string) =>
      //     path ===
      //     `${INCOMLEND_INTERNAL_LINK}/invoice-allocation-new`,
      //   ...styling,
      // },

      {
        title: "Invoice Allocations",
        icon: PriceChangeIcon,
        link: `${INCOMLEND_INTERNAL_LINK}/invoice-allocation-new`,
        match: (path: string) =>
          path === `${INCOMLEND_INTERNAL_LINK}/invoice-allocation-new`,
        ...styling,
        permission: `${FUNDING_ADMIN}|${FUNDING_MEMBER}`,
      },
      {
        title: "Transactions",
        icon: SwapHorizIcon,
        link: `${INCOMLEND_INTERNAL_LINK}/invoice-onboarding/transactions`,
        match: (path: string) =>
          path === `${INCOMLEND_INTERNAL_LINK}/invoice-onboarding/transactions`,
        ...styling,
        permission: PERMISSIONS.invoice_financing_transaction,
      },

      {
        title: "Ewallets",
        icon: AccountBalanceWallet,
        link: `${INCOMLEND_INTERNAL_LINK}/invoice-onboarding/ewallets`,
        match: (path: string) =>
          path === `${INCOMLEND_INTERNAL_LINK}/invoice-onboarding/ewallets`,
        ...styling,
        permission: PERMISSIONS.show_ewallets,
      },
      {
        title: WITHDRAWL_DEPOSITS_MENU_TITLE,
        icon: SwapHorizIcon,
        link: `${INCOMLEND_INTERNAL_LINK}${WITHDRAWL_DEPOSIT_LINK}`,
        ...styling,
        match: (path: string) =>
          path === `${INCOMLEND_INTERNAL_LINK}${WITHDRAWL_DEPOSIT_LINK}`,
        permission: PERMISSIONS.show_withdrawl_deposit,
      },

      {
        title: "Invoices Finance",
        icon: PriceChangeIcon,
        link: `${INCOMLEND_INTERNAL_LINK}/invoice-onboarding/finances`,
        match: (path: string) =>
          path ===
          `${INCOMLEND_INTERNAL_LINK}/invoice-onboarding/finances`,
        ...styling,
        permission: `${FINANCE_ADMIN}|${FINANCE_MEMBER}`,
      },
      // {
      //   title: "Invoice Details",
      //   icon: ReceiptIcon,
      //   link: `${INCOMLEND_INTERNAL_LINK}/invoice-onboarding/invoices/details`,
      //   match: (path: string) => {
      //     return path === `${INCOMLEND_INTERNAL_LINK}/invoice-onboarding/invoices/details` ||
      //            path.startsWith(`${INCOMLEND_INTERNAL_LINK}/invoice-onboarding/invoices/details/`);
      //   },
      //   ...styling,
      //   permission: PERMISSIONS.show_all_accounts,
      // },
    ],
  },
  // {
  //   title: "Leaves",
  //   icon: LeavesIcon,
  //   link: `${INCOMLEND_INTERNAL_LINK}/leaves`,
  //   match: (path) => path === `${INCOMLEND_INTERNAL_LINK}/leaves`,
  //   ...styling,
  //   permission: PERMISSIONS.show_leaves,
  // },
  {
    title: "Organization Chart",
    icon: OrgChart,
    link: `${INCOMLEND_INTERNAL_LINK}${ORG_CHART_LINK}`,
    match: (path) => path === `${INCOMLEND_INTERNAL_LINK}${ORG_CHART_LINK}`,
    ...styling,
    permission: PERMISSIONS.show_organization_chart,
  },

  {
    title: "User Management",
    icon: ConstructionIcon,
    link: `${INCOMLEND_INTERNAL_LINK}${IT_LINK}/user-management`,
    ...styling,
    permission: PERMISSIONS.show_user_management,
  },
  {
    title: "Funder Management",
    icon: BusinessIcon,
    link: `${INCOMLEND_INTERNAL_LINK}${IT_LINK}${FUNDER_MANAGEMENT_LINK}`,
    match: (path) =>
      path === `${INCOMLEND_INTERNAL_LINK}${IT_LINK}${FUNDER_MANAGEMENT_LINK}`,
    ...styling,
    permission: PERMISSIONS.show_funder_management,
  },
  {
    title: "Permissions",
    icon: VpnKeyIcon,
    link: `${INCOMLEND_INTERNAL_LINK}${IT_LINK}/groups`,
    ...styling,
    match: (path) => path === `${INCOMLEND_INTERNAL_LINK}${IT_LINK}/groups`,
    permission: PERMISSIONS.show_user_management,
  },
  // {
  //   title: "Experimental Features",
  //   icon: ScienceIcon,
  //   link: `${INCOMLEND_INTERNAL_LINK}${IT_LINK}/experimental-features`,
  //   ...styling,
  //   match : (path) => path === link,
  //   permission: PERMISSIONS.show_user_management,
  // },
  {
    title: "Configuration",
    icon: Settings,
    link: `${INCOMLEND_INTERNAL_LINK}/configuration`,
    ...styling,
    match: (path) => path === `${INCOMLEND_INTERNAL_LINK}/configuration`,
    permission: PERMISSIONS.show_configuration,
  },
  {
    title: "Scripts",
    icon: HistoryEduIcon,
    link: `${INCOMLEND_INTERNAL_LINK}${IT_LINK}/scripts`,
    ...styling,
    match: (path) => path === `${INCOMLEND_INTERNAL_LINK}${IT_LINK}/scripts`,
    permission: PERMISSIONS.show_scripts,
  },
] as Item[];
